// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/index.js??ref--5-1!../../node_modules/postcss-loader/lib/index.js??ref--5-2!../../node_modules/sass-loader/dist/cjs.js??ref--5-3!../../node_modules/sass-resources-loader/lib/loader.js??ref--5-4!./styles.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js")("72c588f0", content, false, {"sourceMap":false});
// Hot Module Replacement
if(module.hot) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../node_modules/css-loader/index.js??ref--5-1!../../node_modules/postcss-loader/lib/index.js??ref--5-2!../../node_modules/sass-loader/dist/cjs.js??ref--5-3!../../node_modules/sass-resources-loader/lib/loader.js??ref--5-4!./styles.scss", function() {
     var newContent = require("!!../../node_modules/css-loader/index.js??ref--5-1!../../node_modules/postcss-loader/lib/index.js??ref--5-2!../../node_modules/sass-loader/dist/cjs.js??ref--5-3!../../node_modules/sass-resources-loader/lib/loader.js??ref--5-4!./styles.scss");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./assets/scss/styles.scss
// module id = /COo
// module chunks = 13